<template>
  <div>
    <v-container v-if="initialized" class="reporting-obligation-container">
      <v-row>
        <v-col sm="12">
          <h2>DAC6 Registration</h2>
          <p>
            The questionnaire is now complete. This is not yet an actual report in accordance with the statutory
            obligations. If the outcome of this questionnaire is that the advice must or may have to be reported, the
            actual report, if required, will be made by {{ translation_arr[0].translation }}.
          </p>
        </v-col>
      </v-row>
      <div v-if="!result_initialized">
        <v-sheet class="d-flex flex-row">
          <v-skeleton-loader class="mx-auto f-3 mr-5" max-height="364" type="list-item-two-line@5"></v-skeleton-loader>
          <v-skeleton-loader class="mx-auto f-5" max-height="364" type="list-item-two-line@5"></v-skeleton-loader>
        </v-sheet>
      </div>
      <v-form v-model="valid">
        <div class="d-flex flex-column" v-if="result_initialized">
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Client (No.)</p>
            </div>
            <div class="f-4">
              <p>
                {{ customer_questionnaire.customer.companyName }} ({{ customer_questionnaire.customer.relationNumber }})
              </p>
            </div>
            <div class="f-1 align-self-end">
              <p>ID ({{ customer_questionnaire.id }})</p>
            </div>
          </div>
          <result-data lable="Registration date" :value="this.dateFormatted(customer_questionnaire.createdAt)">
          </result-data>
          <result-data lable="Status" :value="customer_questionnaire.status"></result-data>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Job number</p>
            </div>
            <div class="f-5">
              <v-text-field v-model="customer_questionnaire.taskNumber" label="Job number" solo outlined flat dense>
              </v-text-field>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Date (start 30-day-period)</p>
            </div>
            <div class="f-5">
              <v-menu
                v-model="implementation_date_menu"
                :close-on-content-click="true"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="dateFormatted(customer_questionnaire.implementationDate)"
                    prepend-inner-icon="mdi-calendar-range"
                    class="meta-left dateField"
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :rules="required"
                  />
                </template>
                <v-date-picker
                  v-model="customer_questionnaire.implementationDate"
                  :value="dateFormatted(customer_questionnaire.implementationDate)"
                  :first-day-of-week="1"
                  @input="implementation_date_menu = false"
                  :rules="required"
                />
              </v-menu>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Description of arrangement*</p>
            </div>
            <div class="f-5">
              <v-textarea
                v-model="customer_questionnaire.taskRemark"
                label="Description of arrangement"
                value=""
                rows="3"
                solo
                outlined
                flat
                dense
                :rules="rulesTaskRemark"
              ></v-textarea>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Conclusion</p>
            </div>
            <div class="f-5">
              <v-select
                v-model="customer_questionnaire.finalAdvice"
                :items="conclusion_items"
                label="Conclusion"
                solo
                outlined
                flat
                dense
                :disabled="user.roles.indexOf('User') !== -1"
              ></v-select>
            </div>
          </div>
          <div
            class="d-flex flex-row flex-row-wrapper"
            v-if="
              customer_questionnaire.finalAdvice == 'Assessed and eligible for duty of disclosure' ||
                customer_questionnaire.finalAdvice == 'Assessed and not eligible for duty of disclosure'
            "
          >
            <div class="f-3">
              <p>Explanation*</p>
            </div>
            <div class="f-5">
              <v-textarea
                v-model="customer_questionnaire.qrmRemark"
                label="Explanation"
                value=""
                rows="3"
                outlined
                :rules="required"
              ></v-textarea>
            </div>
          </div>
          <div class="panel mb-5" v-if="all_advices.length">
            <div class="panel-header">
              <h3 class="panel-title pa-2">Outcomes</h3>
            </div>
            <div class="panel-body d-flex flex-column pa-4">
              <div v-for="(advice, i) in this.all_advices" :key="i">
                <div class="d-flex flex-row flex-row-wrapper pa-2">
                  <div class="f-3">
                    <p>{{ advice.categoryDisplay }}</p>
                  </div>
                  <div class="f-5 d-flex flex-column mr-4">
                    <v-chip
                      style="align-self: flex-start"
                      class="mb-2"
                      :color="advice.advice == 'Possible reporting obligation' ? 'red' : 'green'"
                      text-color="white"
                    >
                      {{ advice.advice }}
                    </v-chip>
                    <div>{{ advice.conclusionDisplay }}</div>
                    <div
                      v-if="advice.categoryDisplay == 'Hallmarks' && advice.advice == 'Possible reporting obligation'"
                    >
                      Reporting obligation based on Hallmark(s): {{ advice.questionCodes }}
                    </div>
                    <v-divider class="mt-3 mb-3"></v-divider>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column flex-row-wrapper pa-6" v-if="answer_count >= 2">
              <div>
                <p>Should the above outcomes be different in your view? If yes, please state your reasons why.</p>
              </div>
              <div>
                <v-radio-group class="obligated_to_report_buttons" v-model="customer_questionnaire.obligedToReport">
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
                <v-textarea
                  v-if="customer_questionnaire.obligedToReport"
                  v-model="customer_questionnaire.obligedToReportExplanation"
                  label="Provide your reasoning why the outcomes should be different."
                  maxlength="10000"
                  rows="6"
                  outlined
                  :rules="required"
                ></v-textarea>
              </div>
            </div>
          </div>
          <div class="panel mb-5" v-if="all_reports.length">
            <div class="panel-header">
              <h3 class="panel-title pa-2">Disclosure</h3>
            </div>
            <div class="panel-body d-flex flex-column pa-4">
              <div v-for="(report, i) in this.all_reports" :key="i">
                <div class="d-flex flex-row flex-row-wrapper pa-2">
                  <div class="f-3">
                    <p>{{ report.category_display }}</p>
                  </div>
                  <div class="f-5 d-flex flex-column mr-4">
                    <div class="conclusion-display">{{ report.conclusion_display.trim() }}</div>
                    <div class="mt-3" v-if="report.mention_type === 'Form' || report.mention_type === 'Form/Date'">
                      <v-textarea
                        v-model="report.form_mention_answer"
                        label="Enter relevant details here*"
                        maxlength="10000"
                        rows="4"
                        outlined
                        dense
                        :rules="required"
                      ></v-textarea>
                    </div>
                    <result-date-picker
                      v-if="report.mention_type === 'Date' || report.mention_type === 'Form/Date'"
                      :required="true"
                      :clearable="true"
                      :value="report.form_mention_date"
                      :date.sync="report.form_mention_date"
                    ></result-date-picker>

                    <v-divider class="mt-3 mb-3"></v-divider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>{{ translation_arr[1].translation }}</p>
            </div>
            <div class="f-5">
              <v-text-field
                v-model="customer_questionnaire.referenceAdvicepiece"
                :label="translation_arr[1].translation"
                type="number"
                max="9999999"
                solo
                outlined
                flat
                dense
              >
              </v-text-field>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Summary</p>
            </div>
            <div class="f-5">
              <v-textarea
                v-model="customer_questionnaire.resumeResult"
                label="Summary"
                rows="3"
                solo
                outlined
                flat
                dense
              ></v-textarea>
            </div>
          </div>
          <div class="d-flex flex-row flex-row-wrapper">
            <div class="f-3">
              <p>Attach documentation relating to arrangement</p>
            </div>
            <div class="f-5">
              <upload-box class="" @uploaddone="uploadDone" />
              <v-list dense class="pa-0 pt-2">
                <v-list-item
                  v-for="(attachment, i) in attachments"
                  :key="i"
                  class="py-1 px-3 my-3 subtitle-2 list-border"
                  @click="gotoAttachment(attachment)"
                >
                  {{ attachment.name }}
                  <v-spacer />
                  <!-- <v-icon v-if="!deletingFile" @click.stop="startDeleteAttachment(attachment)" class="pl-2"
                    >mdi-trash-can-outline
                  </v-icon>
                  <v-icon v-else class="pl-2">mdi-spin </v-icon> -->
                </v-list-item>
              </v-list>

              <!-- <v-file-input
                :clearable="false"
                :value="documentationFileValue"
                label="No file selected yet..."
                truncate-length="40"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                class="documentation-file-input"
                solo
                outlined
                flat
                dense
              >
                <template v-slot:append>
                  <v-hover v-slot="{ hover }">
                    <v-icon :color="hover ? 'bdoRed' : ''" @click="downloadDocumentation()">mdi-download </v-icon>
                  </v-hover>
                </template>
              </v-file-input> -->
            </div>
          </div>
        </div>
        <div class="d-flex flex-row">
          <div class="d-flex flex-column f-1">
            <v-btn
              v-if="qrmValid"
              class="primary-btn"
              @click="submit"
              height="36px"
              width="200px"
              color="bdoRed white--text"
            >
              Save
            </v-btn>
            <v-btn
              v-else
              class="primary-btn"
              @click="submit"
              :disabled="!valid"
              height="36px"
              width="200px"
              color="bdoRed white--text"
            >
              Save
            </v-btn>

            <v-menu offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="primary-btn export-btn mt-3"
                  height="36px"
                  width="200px"
                  color="bdoRed white--text"
                  v-bind="attrs"
                  v-on="on"
                  :loading="export_loading"
                >
                  Export
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(possible_export, index) in possible_exports"
                  :key="index"
                  @click="exportTo(possible_export.action)"
                  class="export-list-item"
                >
                  <v-list-item-title>{{ possible_export.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="d-flex flex-column f-1 align-items-end">
            <v-btn
              class="primary-btn"
              height="36px"
              width="200px"
              color="bdoBlack white--text"
              @click="viewQuestionnaire"
            >
              View questionnaire
            </v-btn>
            <v-btn
              class="primary-btn mt-3"
              height="36px"
              width="200px"
              color="bdoBlack white--text"
              @click="backToOverview"
            >
              Back to overview
            </v-btn>
          </div>
        </div>
      </v-form>
      <div class="mt-7">
        <p>
          If this registration needs to be amended, please contact {{ translation_arr[0].translation }} as you cannot
          amend the registration yourself.
        </p>
      </div>
    </v-container>
    <v-dialog tile v-model="deleteAttachmentModal" persistent max-width="460">
      <v-card class="pb-4">
        <v-card-title class="headline primaryStart white--text">
          <span>Hold on!</span>
          <v-btn class="white--text" outlined icon @click="deleteAttachmentModal = false">
            <v-icon class="white--text">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-8">
          <h4 class="pb-4 primaryStart--text">Deleting Attachment</h4>
          <span>
            Are you sure you want to delete this attachment? Deleting this attachment will remove it permanently.</span
          >
        </v-card-text>
        <v-card-actions class="pt-6">
          <v-spacer></v-spacer>
          <v-btn
            color="primaryStart"
            outlined
            text
            @click="deleteAttachmentModal = false"
            :disabled="deletingAttachment"
          >
            Cancel
            <v-icon class="primaryStart--text">mdi-close</v-icon>
          </v-btn>
          <v-btn
            color="primaryStart"
            class="white--text elevation-0"
            @click="deleteAttachment"
            :loading="deletingAttachment"
          >
            Accept
            <v-icon class="white--text">mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { mapGetters } from 'vuex'
import helpers from '@/plugins/helpers'
import config from '@/config'
import resultData from './components/resultData'
import resultDatePicker from './components/resultDatePicker'
import UploadBox from './components/upload-box.vue'
export default {
  components: {
    resultData,
    resultDatePicker,
    UploadBox
  },
  data: () => ({
    initialized: false,
    result_initialized: false,
    translation_arr: [
      {
        label: 'BVT',
        translation: 'BVT'
      },
      {
        label: 'Reference Advice Documents M-files',
        translation: 'Reference Advice Documents M-files'
      },
      {
        label: 'Reference Report Documents M-files',
        translation: 'Reference Report Documents M-files'
      }
    ],
    customer_questionnaire: {},
    all_advices: [],
    all_reports: [],
    implementation_date_menu: false,
    date_picker: '',
    conclusion_items: [
      'Possible reporting obligation',
      'No reporting obligation',
      'Assessed and eligible for duty of disclosure',
      'Assessed and not eligible for duty of disclosure'
    ],
    answer_count: 0,
    export_loading: false,
    possible_exports: [
      { title: 'PDF', action: 'PDF' },
      { title: 'PDF (QUESTIONS ONLY)', action: 'QuestionsAsPDF' },
      { title: 'PDF Excel', action: 'Excel' }
    ],
    deleteAttachmentModal: false,
    deleteAttachment: false,
    deletingAttachment: false,
    attachments: [],
    valid: false,
    required: [v => !!v || 'This field is required'],
    rulesTaskRemark: [
      v => !!v || 'This field is required',
      v => (v || '').length < 500 || 'Description of arrangement cannot contain more than 500 characters'
    ]
  }),
  computed: {
    ...mapGetters({
      user: 'general/user',
      countrycode: 'general/countrycode'
    }),
    documentationFileValue() {
      const file = new File(
        [this.customer_questionnaire.additionalFileName],
        this.customer_questionnaire.additionalFileName
      )
      if (file.name == '' || file.name == 'null') {
        return null
      } else {
        return new File(
          [this.customer_questionnaire.additionalFileName],
          this.customer_questionnaire.additionalFileName
        )
      }
    },
    qrmValid() {
      let val = null
      if (this.user.roles.indexOf('QRM') !== -1) val = true
      else val = false
      return val
    }
  },
  async mounted() {
    this.getCountryTranslations()
    this.getCustomerQuestionnaire()
    this.getCustomerQuestionnaireAvices()
    this.CustomerQuestionnaireReports()
    this.getAnwersCount()
    this.getFiles()
  },
  methods: {
    exportTo(e) {
      switch (e) {
        case 'PDF':
          this.downloadAsPDF()
          break
        case 'QuestionsAsPDF':
          this.downloadQuestionsAsPDF()
          break
        case 'Excel':
          this.downloadAsExcel()
          break
        default:
          break
      }
    },
    // async methods
    async getCountryTranslations() {
      let query = `{
        allTranslation(where: { country: { code : { eq: "${this.countrycode}" }} translationSubject: { label : { neq: null }}}) {
          results{
            id
            subjectLabel
            translation
            translationSubject {
              label
            }
          }
        }
      }`
      let results = await helpers.fetchGraph(query)
      let translations = results.data.allTranslation.results
      if (translations.length) {
        for (let trans in translations) {
          if (translations[trans].translationSubject.label) {
            let index = this.translation_arr.findIndex(
              obj => obj.label === translations[trans].translationSubject.label
            )
            if (index != undefined) {
              this.translation_arr[index].translation = translations[trans].translation
            }
          }
        }
      }
      this.initialized = true
    },
    async getCustomerQuestionnaire() {
      let query = `{
        oneCustomerquestionnaire(where: { id: { eq : ${this.$route.params.id} }}) {
          id
          createdAt
          status
          taskNumber
          taskRemark
          implementationDate
          finalAdvice
          qrmRemark
          obligedToReport
          obligedToReportExplanation
          referenceAdvicepiece
          resumeResult
          additionalFileName
          additionalFile
          customer{
            companyName
            relationNumber
          }
        }
      }`
      let results = await helpers.fetchGraph(query)
      if (results.data.oneCustomerquestionnaire) {
        this.customer_questionnaire = results.data.oneCustomerquestionnaire
        this.result_initialized = true
      }
    },
    async getCustomerQuestionnaireAvices() {
      let query = `{
        allGegenereerdeAdviezen(
            sort:{field: priority, order: ASC},
            where:{
              _and:[
                {customerQuestionnaire:{id:{eq: ${this.$route.params.id}}}}
                {adviceRecord: {recordType: {eq:"Advice"}}}
              ]
          }) {
          results{
            id
            categoryDisplay
            advice
            conclusionDisplay
            questionCodes
          }
        }
      }`
      let results = await helpers.fetchGraph(query)
      if (results.data.allGegenereerdeAdviezen) {
        this.all_advices = results.data.allGegenereerdeAdviezen.results
      }
    },
    async CustomerQuestionnaireReports() {
      let query = `{
        allGegenereerdeAdviezen(
            sort:{field: priority, order: ASC},
            where:{
              _and:[
                {customerQuestionnaire:{id:{eq: ${this.$route.params.id}}}}
                {adviceRecord: {recordType: {eq:"Report"}}}
              ]
          }) {
          results{
            id
            categoryDisplay
            advice
            conclusionDisplay
            questionCodes
            mentionType
            formMentionAnswer
            formMentionDate
          }
        }
      }`
      let results = await helpers.fetchGraph(query)
      if (results.data.allGegenereerdeAdviezen) {
        for (let a = 0; a < results.data.allGegenereerdeAdviezen.results.length; a++) {
          let advice = {
            id: results.data.allGegenereerdeAdviezen.results[a].id,
            mention_type: results.data.allGegenereerdeAdviezen.results[a].mentionType,
            form_mention_date: results.data.allGegenereerdeAdviezen.results[a].formMentionDate,
            advice: results.data.allGegenereerdeAdviezen.results[a].advice,
            form_mention_answer: results.data.allGegenereerdeAdviezen.results[a].formMentionAnswer,
            category_display: results.data.allGegenereerdeAdviezen.results[a].categoryDisplay,
            conclusion_display: results.data.allGegenereerdeAdviezen.results[a].conclusionDisplay
          }
          this.all_reports.push(advice)
        }
        //this.all_reports = results.data.allGegenereerdeAdviezen.results
      }
    },
    async getAnwersCount() {
      let query = `{
        allAnswer(where: {customerQuestionnaire: { id: {eq : ${this.$route.params.id} }}}) {
          totalCount
        }
      }`
      let results = await helpers.fetchGraph(query)
      if (results.data.allAnswer) {
        this.answer_count = results.data.allAnswer.totalCount
      }
    },
    async submit() {
      this.$store.commit('general/SET_LOADING', { state: true })
      var data = {
        _csrf: this.user.csrf,
        id: this.customer_questionnaire.id,
        result: {
          mentions: this.all_reports,
          obliged_to_report: this.customer_questionnaire.obligedToReport,
          obliged_to_report_explanation: this.customer_questionnaire.obligedToReportExplanation,
          resume_result: this.customer_questionnaire.resumeResult,
          reference_advicepiece: this.customer_questionnaire.referenceAdvicepiece,
          task_remark: this.customer_questionnaire.taskRemark,
          task_number: this.customer_questionnaire.taskNumber,
          final_advice: this.customer_questionnaire.finalAdvice,
          qrm_remark: this.customer_questionnaire.qrmRemark,
          implementation_date: this.customer_questionnaire.implementationDate
        }
      }

      let response = await helpers.fetchApi(config.apiUrl + `customer-questionnaire/result`, 'POST', data)
      if (response) {
        if (response.statusCode == 200) {
          this.$store.commit('general/SET_SNACKBAR', {
            msg: 'Save successfull',
            status: ' white',
            color: 'success'
          })
        } else {
          this.$store.commit('general/SET_SNACKBAR', {
            msg: 'Something went wrong',
            status: ' white',
            color: 'error'
          })
        }
        this.$store.commit('general/SET_LOADING', { state: false })
      }
    },

    // non-async methods
    dateFormatted(date) {
      return date ? format(date, 'DD-MM-YYYY') : ''
    },
    downloadDocumentation() {
      if (this.customer_questionnaire.additionalFile.url) {
        this.openDownload(this.customer_questionnaire.additionalFile.url)
      }
    },
    openDownload(url) {
      if (url && url.length > 0) {
        window.open(url, '_blank')
      }
    },
    async downloadAsPDF() {
      this.export_loading = true
      let response = await helpers.fetchApi(
        config.apiUrl + 'customer-questionnaire/' + this.customer_questionnaire.id + '/export-pdf',
        'GET'
      )
      if (response) {
        window.open(response.url, '_blank')
        // if (response.url) {

        // }
        this.export_loading = false
      }
    },
    async downloadQuestionsAsPDF() {
      this.export_loading = true
      let response = await helpers.fetchApi(
        config.apiUrl + 'customer-questionnaire/' + this.customer_questionnaire.id + '/export-questions-pdf',
        'GET'
      )
      if (response) {
        window.open(response.url, '_blank')
        // if (response.url) {

        // }
        this.export_loading = false
      }
    },
    async downloadAsExcel() {
      this.export_loading = true
      let response = await helpers.fetchApi(
        config.apiUrl + 'customer-questionnaire/' + this.customer_questionnaire.id + '/export-excel',
        'GET'
      )
      if (response) {
        window.open(response.url, '_blank')
        // if (response.url) {

        // }
        this.export_loading = false
      }
    },
    viewQuestionnaire() {
      this.$router.push({ path: `/${this.countrycode}/questionnaire/${this.customer_questionnaire.id}` })
    },
    backToOverview() {
      this.$router.push({ path: `/${this.countrycode}/questionnaires` })
    },
    uploadDone() {
      this.getFiles()
    },
    async getFiles() {
      let attachmentArr = []
      if (this.$route.params.id) {
        let query = `{
          oneCustomerquestionnaire(where: { id: { eq : ${this.$route.params.id} }}) {
            id
            additionalFile
          }
        }`
        let files = await helpers.fetchGraph(query)
        if (files && files.data.oneCustomerquestionnaire.additionalFile.url) {
          let el = {
            name: files.data.oneCustomerquestionnaire.additionalFile.name,
            file: files.data.oneCustomerquestionnaire.additionalFile.url
          }
          attachmentArr.push(el)
        }
        this.attachments = attachmentArr
      }
    },
    gotoAttachment(attachment) {
      let fileUrl = attachment.file
      window.open(fileUrl, '_blank')
    },
    startDeleteAttachment(attachment) {
      if (attachment) {
        this.deleteAttachmentModal = true
        this.selectedAttachment = attachment
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';
.reporting-obligation-container p,
.reporting-obligation-container .v-text-field {
  font-size: 14px;
  & .report-datepicker {
    max-width: 300px !important;
  }
}
.flex-row-wrapper {
  flex-flow: row nowrap;
  align-items: stretch;
  & div:first-child p {
    font-weight: bold;
  }
}
.flex-column-wrapper {
  flex-flow: column nowrap;
  align-items: stretch;
  & div:first-child p {
    font-weight: bold;
  }
}
.obligated_to_report_buttons {
  margin-top: 0px;
}
.f-1 {
  flex: 1;
}
.f-3 {
  flex: 3;
}
.f-4 {
  flex: 4;
}
.f-5 {
  flex: 5;
}
.align-self-end {
  align-self: end;
}
.align-items-end {
  align-items: flex-end;
}
.panel {
  width: 100%;
  border: 1px solid #ddd;
  & .panel-header {
    background: #f5f5f5;
  }
  & .panel-title {
    font-size: 16px;
  }
  & .conclusion-display {
    white-space: pre-line;
  }
}
.export-list-item:hover {
  font-weight: bold;
  cursor: pointer;
  & .v-list-item__title {
    color: $bdo-red;
  }
}
</style>
